module.exports = __webpack_public_path__ + "prediction-arrow-8854e45ec741fb1c6bb57279ff1bf712.svg";